import { createContext, useContext } from 'react';
import {
  JobWatcherState,
  useIndirectTaxJobWatcher,
} from './useIndirectTaxJobWatcher';

const JobWatcherContext = createContext<JobWatcherState | null>(null);

interface SalesTaxJobsLogProviderProps {
  children: React.ReactNode;
  corporationId: number;
}

export const SalesTaxJobsLogProvider = ({
  children,
  corporationId,
}: SalesTaxJobsLogProviderProps) => {
  const jobWatcherState = useIndirectTaxJobWatcher({
    corporation_id: corporationId,
  });

  return (
    <JobWatcherContext.Provider value={jobWatcherState}>
      {children}
    </JobWatcherContext.Provider>
  );
};

export const useJobWatcherContext = () => {
  const context = useContext(JobWatcherContext);
  if (!context) {
    throw new Error(
      'useJobWatcherContext must be used within SalesTaxJobsLogProvider'
    );
  }
  return context;
};
